import Table from './Table';
export default Table;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/table/index.js
// module id = 350
// module chunks = 0